import type { Marked } from 'marked';
import { SanitationLevel, sanitize } from '@ardoq/html';
import { addAlignmentToLegacyTables } from './addAlignmentToLegacyTables';
import { collapseMultilineTableRows } from './collapseMultilineTableRows';
import { buildConverter, postProcessHtml } from './markedArdoqPlugins';
import { BR_MARKER, BR_MARKER_RE } from './brMarker';
import type { MarkdownFlavor } from '../markdownFlavor';

const converters: Record<MarkdownFlavor, Marked> = {
  original: buildConverter('original'),
  github: buildConverter('github'),
};

const markdownToSanitizedHTML = (
  markdownText: string | undefined | null,
  sanitationLevel: SanitationLevel,
  markdownFlavor?: MarkdownFlavor
): string => {
  if (!markdownText) return '';
  const withAlignment = addAlignmentToLegacyTables(markdownText);
  const withCollapsedRows = collapseMultilineTableRows(withAlignment);
  const preprocessed = withCollapsedRows.replace(/ {2}\n/gm, `${BR_MARKER}\n`);
  const converter = converters[markdownFlavor ?? 'original'];
  const rendered = converter
    .parse(preprocessed, { async: false })
    .replace(/\n$/, '');
  const transformed = postProcessHtml(rendered).replace(BR_MARKER_RE, '<br>\n');
  return sanitize(transformed, sanitationLevel);
};

export { markdownToSanitizedHTML };
